import { put, takeLatest, all, fork, select, join } from 'redux-saga/effects';
import { putStaffLoadingStatus, setStaff, showStaffError, STAFF_ACTIONS, putCountStaff, fetchStaff } from './actions';
import { getStaff, getCountStaff } from './services';

export function* callFetchAllStaff() {
  try {
    yield put(putStaffLoadingStatus(true));

    const offset = yield select((state) => state.get('staffList').get('offset'));
    const order = yield select((state) => state.get('staffList').get('order'));
    const sortBy = yield select((state) => state.get('staffList').get('sortBy'));
    const searchText = yield select((state) => state.get('staffList').get('searchText'));
    const res = yield fork(getStaff, offset, sortBy, order, searchText);
    const { allUsers, errors } = yield join(res);

    if (errors) {
      yield put(showStaffError());
    } else {
      yield put(setStaff(allUsers));
    }
  } catch {
    yield put(showStaffError());
  } finally {
    yield put(putStaffLoadingStatus(false));
  }
}

export function* callFetchCountStaff() {
  try {
    const res = yield fork(getCountStaff);
    const { allUsersCount, errors } = yield join(res);

    if (errors) {
      yield put(showStaffError());
    } else {
      yield put(putCountStaff(allUsersCount));
    }
  } catch {
    yield put(showStaffError());
  }
}

export function* callSetOrderUsers() {
  yield put(fetchStaff());
}

function* watchCallFetchAllStaff() {
  yield takeLatest(STAFF_ACTIONS.FETCH_ALL_STAFF, callFetchAllStaff);
}

function* watchCallFetchCountStaff() {
  yield takeLatest(STAFF_ACTIONS.FETCH_COUNT_STAFF, callFetchCountStaff);
}

function* watchCallSetOrderUsers() {
  yield takeLatest(STAFF_ACTIONS.SET_ORDER, callSetOrderUsers);
}

export default function* staffListSaga() {
  yield all([fork(watchCallFetchAllStaff), fork(watchCallFetchCountStaff), fork(watchCallSetOrderUsers)]);
}
